export default __webpack_public_path__ + "static/media/AlexWilson.e8a01cfc.jpg";